import axios from "axios";
import { fetchAuthSession } from 'aws-amplify/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://api.agrosuper.mooestroportal.com"
});

// Interceptor para agregar el token de Cognito a cada request
api.interceptors.request.use(
  async (config) => {
    try {
      // Obtener el token de acceso de Cognito
      const session = await fetchAuthSession();
      const token = session.tokens?.accessToken?.toString();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      // Si falla la obtención del token, continuar sin autorización
      console.warn('No se pudo obtener token de autenticación:', error);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si recibimos 401 Unauthorized
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Intentar refrescar el token
        const session = await fetchAuthSession({ forceRefresh: true });
        const token = session.tokens?.accessToken?.toString();

        if (token) {
          // Actualizar el header de autorización
          originalRequest.headers.Authorization = `Bearer ${token}`;
          // Reintentar la petición original
          return api(originalRequest);
        }
      } catch (refreshError) {
        // Si falla el refresh, redirigir al login
        console.error('Error al refrescar token:', refreshError);
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    // Si es 403 Forbidden, puede ser falta de permisos
    if (error.response?.status === 403) {
      console.error('Acceso denegado: No tienes permisos para realizar esta acción');
    }

    return Promise.reject(error);
  }
);

export default api;